module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/sol-logo-c-word.843346c.png";